import { IonText } from '@ionic/react';
import { ReactElement, forwardRef } from 'react';
import './flow-item.css';

interface FlowItemBoundaryProps {
  text?: string;
}

const FlowItemBoundary = forwardRef<HTMLDivElement, FlowItemBoundaryProps>(
  (props: FlowItemBoundaryProps, ref): ReactElement => {
    return (
      <div ref={ref} className={'flow-item-boundary-container'}>
        <div className={'flow-item-boundary'}>
          <IonText>{props.text}</IonText>
        </div>
      </div>
    );
  }
);

FlowItemBoundary.displayName = 'FlowItemBoundary';

export { FlowItemBoundary };
